import React from 'react';
import { File } from './types';
import { Config, TableConfig } from '../../types';

interface Props {
    file: File;
    config: Config;
    setEditFile: Function;
    handleUpdate: Function;
    tableConfig: TableConfig;
    pushFile: ((file: File) => void) | null;
    removeFile: ((file: File) => void) | null;
}

const FileComponent = ({file, config, setEditFile, handleUpdate, tableConfig, pushFile, removeFile}: Props) => {
    const drag = (ev: { dataTransfer: { setData: (arg0: string, arg1: string) => void; }; }) => {
        ev.dataTransfer.setData("file", JSON.stringify(file));
    }

    const handleImportant = (important: boolean) => {
        const newFile = {
            ...file,
            important: important
        }
        handleUpdate(newFile)
    }

    return (
        <tr draggable={config.admin ? true : false} onDragStart={config.admin ? drag : undefined}>
            <td>
                {file.index}
            </td>
            <td>
                <a href={`${config.siteurl}/${config.directory}${file.path}`}>{file.text}</a>
            </td>
            <td>
                {
                    config.admin && tableConfig.addAndRemove === true && pushFile ?
                    <button className="rowbtn success-alpha" onClick={() => pushFile(file)}>+</button>
                    : null
                }
                {
                    config.admin && tableConfig.addAndRemove === true && removeFile ?
                    <button className="rowbtn danger-alpha" onClick={() => removeFile(file)}>-</button>
                    : null
                }
                {
                    config.admin && tableConfig.important === "add" ?
                    <button className="rowbtn success-alpha" onClick={() => handleImportant(true)}>!</button>
                    : null
                }
                {
                    config.admin && tableConfig.important === "remove" ?
                    <button className="rowbtn danger-alpha" onClick={() => handleImportant(false)}>x</button>
                    : null
                }
            </td>
            <td>
            {
                config.admin ? 
                <React.Fragment>
                    <button className="textbtn edit" onClick={() => setEditFile()}>Muokkaa</button>
                </React.Fragment>
                : null
            }
            </td>
        </tr>
    )
}

export default FileComponent